export const apiEndpoint = "https://r0lhqphcx6.execute-api.us-east-2.amazonaws.com/pro";
